var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificateTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1218_2362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5412 7.20758C46.791 3.82215 52.209 3.82214 55.4588 7.20758C57.4804 9.31356 60.4655 10.1954 63.3067 9.52478C67.8509 8.45211 72.3938 11.4358 73.3072 16.0148C73.8798 18.8848 75.9224 21.2862 78.6766 22.2757C83.0867 23.8602 85.3055 28.8214 83.6158 33.1923C82.5575 35.9302 82.9949 39.0623 84.7783 41.3937C87.637 45.131 86.88 50.5052 83.084 53.2854C80.7189 55.0175 79.4324 57.9026 79.6838 60.8233C80.0845 65.4788 76.5669 69.626 71.9017 69.8905C68.9844 70.0559 66.3578 71.7681 65.0078 74.3595C62.8471 78.507 57.6495 80.068 53.59 77.7462C51.0559 76.2969 47.9441 76.2969 45.41 77.7462C41.3505 80.068 36.1529 78.507 33.9922 74.3595C32.6422 71.7681 30.0156 70.0559 27.0983 69.8905C22.4331 69.626 18.9155 65.4788 19.3162 60.8233C19.5676 57.9026 18.2811 55.0175 15.916 53.2854C12.12 50.5052 11.363 45.131 14.2217 41.3937C16.0051 39.0623 16.4425 35.9302 15.3842 33.1923C13.6945 28.8214 15.9133 23.8602 20.3234 22.2757C23.0776 21.2862 25.1203 18.8848 25.6928 16.0148C26.6062 11.4358 31.1491 8.45211 35.6933 9.52478C38.5345 10.1954 41.5196 9.31356 43.5412 7.20758Z",
    fill: "url(#paint0_linear_1218_2362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5412 7.20758C46.791 3.82215 52.209 3.82214 55.4588 7.20758C57.4804 9.31356 60.4655 10.1954 63.3067 9.52478C67.8509 8.45211 72.3938 11.4358 73.3072 16.0148C73.8798 18.8848 75.9224 21.2862 78.6766 22.2757C83.0867 23.8602 85.3055 28.8214 83.6158 33.1923C82.5575 35.9302 82.9949 39.0623 84.7783 41.3937C87.637 45.131 86.88 50.5052 83.084 53.2854C80.7189 55.0175 79.4324 57.9026 79.6838 60.8233C80.0845 65.4788 76.5669 69.626 71.9017 69.8905C68.9844 70.0559 66.3578 71.7681 65.0078 74.3595C62.8471 78.507 57.6495 80.068 53.59 77.7462C51.0559 76.2969 47.9441 76.2969 45.41 77.7462C41.3505 80.068 36.1529 78.507 33.9922 74.3595C32.6422 71.7681 30.0156 70.0559 27.0983 69.8905C22.4331 69.626 18.9155 65.4788 19.3162 60.8233C19.5676 57.9026 18.2811 55.0175 15.916 53.2854C12.12 50.5052 11.363 45.131 14.2217 41.3937C16.0051 39.0623 16.4425 35.9302 15.3842 33.1923C13.6945 28.8214 15.9133 23.8602 20.3234 22.2757C23.0776 21.2862 25.1203 18.8848 25.6928 16.0148C26.6062 11.4358 31.1491 8.45211 35.6933 9.52478C38.5345 10.1954 41.5196 9.31356 43.5412 7.20758Z",
    fill: "url(#paint1_linear_1218_2362)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 42.0487C24.4199 28.1974 35.6486 16.9688 49.4999 16.9688C63.3511 16.9688 74.5798 28.1974 74.5798 42.0487V42.6262C74.5798 56.4775 63.3511 67.7061 49.4999 67.7061C35.6486 67.7061 24.4199 56.4775 24.4199 42.6262V42.0487Z",
    fill: "black",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 42.0487C24.4199 28.1974 35.6486 16.9688 49.4999 16.9688C63.3511 16.9688 74.5798 28.1974 74.5798 42.0487V42.6262C74.5798 56.4775 63.3511 67.7061 49.4999 67.7061C35.6486 67.7061 24.4199 56.4775 24.4199 42.6262V42.0487Z",
    stroke: "url(#paint2_radial_1218_2362)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 42.0487C24.4199 28.1974 35.6486 16.9688 49.4999 16.9688C63.3511 16.9688 74.5798 28.1974 74.5798 42.0487V42.6262C74.5798 56.4775 63.3511 67.7061 49.4999 67.7061C35.6486 67.7061 24.4199 56.4775 24.4199 42.6262V42.0487Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M44.8724 47.4625L39.4808 42.0154C39.1905 41.7215 38.7964 41.5563 38.3854 41.5563C37.9743 41.5563 37.5802 41.7215 37.2899 42.0154C36.684 42.6276 36.684 43.6166 37.2899 44.2288L43.7848 50.7904C44.3908 51.4026 45.3696 51.4026 45.9756 50.7904L62.4147 34.1823C63.0207 33.5701 63.0207 32.5811 62.4147 31.9689C62.1244 31.675 61.7303 31.5098 61.3193 31.5098C60.9083 31.5098 60.5142 31.675 60.2239 31.9689L44.8724 47.4625Z",
    fill: "white",
    stroke: "#FDFDFD",
    strokeWidth: 2.55103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.959 42.5952C77.959 58.3129 65.2172 71.0547 49.4995 71.0547C33.7818 71.0547 21.04 58.3129 21.04 42.5952C21.04 26.8775 33.7818 14.1357 49.4995 14.1357C65.2172 14.1357 77.959 26.8775 77.959 42.5952ZM26.8992 42.5952C26.8992 55.077 37.0177 65.1955 49.4995 65.1955C61.9813 65.1955 72.0998 55.077 72.0998 42.5952C72.0998 30.1134 61.9813 19.9949 49.4995 19.9949C37.0177 19.9949 26.8992 30.1134 26.8992 42.5952Z",
    fill: "url(#paint3_linear_1218_2362)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1218_2362",
    x: -3,
    y: -3,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.690196 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1218_2362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1218_2362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1218_2362",
    x1: 23.2224,
    y1: 8.58529,
    x2: 67.6505,
    y2: 78.6137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1218_2362",
    x1: -4.91049,
    y1: -5.32813,
    x2: 56.6199,
    y2: 104.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1218_2362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.48278 19.7731) rotate(35.3875) scale(64.9669 38.5093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1218_2362",
    x1: 49.4995,
    y1: 14.1357,
    x2: 49.4995,
    y2: 71.0547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateTick);
export default __webpack_public_path__ + "static/media/certificateTick.c1b73c2df00ec2a21c2d8fd3a28fe4d1.svg";
export { ForwardRef as ReactComponent };